module.exports = __webpack_public_path__ + "img/untec.91487e52.png";